// Get the API URL based on environment
console.log("VERSION", process.env.REACT_APP_VERSION)

export const url = process.env.REACT_APP_WEB_URL;
export const apiURL = process.env.REACT_APP_API_URL;

export const Api_Endpoints = {
  login_Endpoint: `${apiURL}/login`,
  INVOICE_DETAILS: `${apiURL}/invoice/Details`,
  INVOICE_LIST: `${apiURL}/invoice/list`,
  INVOICE_ADD: `${apiURL}/invoice/add`,
  INVOICE_ACTION: `${apiURL}/invoice/update`,
  VENDOR_ADD: `${apiURL}/vendor/add`,
  VENDOR_LIST: `${apiURL}/vendor/list`,
  VENDOR_DETAILS: `${apiURL}/vendor/Details`,
  VENDOR_ACTION: `${apiURL}/vendor/update`,
  DASHBOARD_COUNT: `${apiURL}/dashboard/count`,
  DASHBOARD_DROPDOWN: `${apiURL}/dashboard/dropdowns`,
  PINCODE: `${apiURL}/vendor/fetch`,
  VENDOR_SEARCH: `${apiURL}/vendor/search`,
  INVOICE_SEARCH: `${apiURL}/invoice/search`,
  VENDOR_FILTER: `${apiURL}/vendor/status`,
  INVOICE_FILTER: `${apiURL}/invoice/status`,
  INVOICE_DOWNLOAD: `${apiURL}/invoice/download`,
  INVOICE_PDF_GENERATE: `${apiURL}/invoice/generate_pdf`,
  INVOICE_EXPORT_EXCEL_FILE: `${apiURL}/invoice/import`,
  INVOICE_SHOW_INVOICE: `${apiURL}/invoice/show_invoices`,
  EXCEL_STATEMENT_DOWNLOAD: `${apiURL}/invoice/report`,
  UPDATE_Password: `${apiURL}/update_password`,
  VERIFY_OTP: `${apiURL}/verifyotp`,
  FORGET_Password: `${apiURL}/forget_password`,
  RESEND_OTP: `${apiURL}/resendotp`,
  VENDOR_SAVE_DRAFT: `${apiURL}/vendor/save`,
  VENDOR_SAVE_DRAFT_LIST: `${apiURL}/vendor/list_draft`,
  VENDOR_SAVE_DRAFT_DETAILS: `${apiURL}/vendor/save_details`,
};